import { useState } from "react";
import client from "../api/client";

const styles = {
  card: {
    border: 0,
    borderRadius: 14,
    boxShadow: "0 2px 10px rgba(0,0,0,.08)",
    overflow: "hidden",
    background: "#fff",
  },
  header: {
    background: "linear-gradient(90deg,#0b4f4a,#0f766e)",
    color: "#fff",
    padding: "9px 12px",
  },
  title: { fontSize: 13, fontWeight: 700, margin: 0 },
  sub: { fontSize: 10, opacity: 0.85 },
  body: { padding: 12, fontSize: 11 },
  filterBox: {
    background: "#f8f9fa",
    border: "1px solid #e9ecef",
    borderRadius: 12,
    padding: 10,
    marginBottom: 10,
  },
  label: { fontSize: 10, fontWeight: 700, marginBottom: 3, color: "#495057" },
  input: { height: 30, fontSize: 11, borderRadius: 7 },
  btn: { height: 30, fontSize: 11, borderRadius: 7, fontWeight: 600 },
  th: {
    fontSize: 10,
    padding: "7px 8px",
    whiteSpace: "nowrap",
    color: "#fff",
    background: "#07111f",
  },
  td: {
    fontSize: 11,
    padding: "6px 8px",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
  longTd: {
    fontSize: 11,
    padding: "6px 8px",
    verticalAlign: "middle",
    minWidth: 260,
    whiteSpace: "normal",
  },
  badge: {
    fontSize: 10,
    padding: "4px 7px",
    borderRadius: 20,
    fontWeight: 600,
  },
};

export default function UserActivityPage() {
  const [filter, setFilter] = useState({
    fromDate: "",
    toDate: "",
    userName: "",
    activityType: "",
  });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const set = (key, value) => setFilter((p) => ({ ...p, [key]: value }));
  const formatDate = (value) =>
    value ? String(value).replace("T", " ").slice(0, 19) : "-";
  const qs = () =>
    new URLSearchParams(
      Object.fromEntries(Object.entries(filter).filter(([_, v]) => v)),
    ).toString();

  const load = async () => {
    setLoading(true);
    try {
      const res = await client.get(`/audittrail/user-activity?${qs()}`);
      setRows(res.data || []);
    } finally {
      setLoading(false);
    }
  };

  const clear = () => {
    setFilter({ fromDate: "", toDate: "", userName: "", activityType: "" });
    setRows([]);
  };

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <h6 style={styles.title}>
          <i className="bi bi-person-lines-fill me-2"></i>User Activity Tracking
        </h6>
        <div style={styles.sub}>
          Track login, logout, navigation and important user actions
        </div>
      </div>
      <div style={styles.body}>
        <div style={styles.filterBox}>
          <div className="row g-2">
            <div className="col-md-2">
              <label style={styles.label}>From</label>
              <input
                type="date"
                className="form-control form-control-sm"
                style={styles.input}
                value={filter.fromDate}
                onChange={(e) => set("fromDate", e.target.value)}
                placeholder="From"
              />
            </div>
            <div className="col-md-2">
              <label style={styles.label}>To</label>
              <input
                type="date"
                className="form-control form-control-sm"
                style={styles.input}
                value={filter.toDate}
                onChange={(e) => set("toDate", e.target.value)}
                placeholder="To"
              />
            </div>
            <div className="col-md-2">
              <label style={styles.label}>User</label>
              <input
                type="text"
                className="form-control form-control-sm"
                style={styles.input}
                value={filter.userName}
                onChange={(e) => set("userName", e.target.value)}
                placeholder="User"
              />
            </div>
            <div className="col-md-2">
              <label style={styles.label}>Activity</label>
              <input
                type="text"
                className="form-control form-control-sm"
                style={styles.input}
                value={filter.activityType}
                onChange={(e) => set("activityType", e.target.value)}
                placeholder="Activity"
              />
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <button
                className="btn btn-primary btn-sm w-100"
                style={styles.btn}
                onClick={load}
                disabled={loading}
              >
                <i className="bi bi-search me-1"></i>
                {loading ? "Loading..." : "Load"}
              </button>
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <button
                className="btn btn-outline-secondary btn-sm w-100"
                style={styles.btn}
                onClick={clear}
              >
                <i className="bi bi-x-circle me-1"></i>Clear
              </button>
            </div>
          </div>
        </div>
        <div
          className="d-flex justify-content-between mb-2"
          style={{ fontSize: 10, color: "#6c757d" }}
        >
          <span>
            <i className="bi bi-database me-1"></i>Total Records:{" "}
            <strong>{rows.length}</strong>
          </span>
          <span>Security monitoring</span>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table className="table table-sm table-hover align-middle mb-0">
            <thead>
              <tr>
                <th style={styles.th}>Date</th>
                <th style={styles.th}>User</th>
                <th style={styles.th}>Activity</th>
                <th style={styles.th}>Page</th>
                <th style={styles.th}>Description</th>
                <th style={styles.th}>IP</th>
                <th style={styles.th}>Browser</th>
              </tr>
            </thead>
            <tbody>
              {rows.length ? (
                rows.map((r, i) => (
                  <tr key={i}>
                    <td style={styles.td}>
                      formatDate(r.createdAt || r.CreatedAt)
                    </td>
                    <td style={styles.td}>r.userName || r.UserName || "-"</td>
                    <td style={styles.td}>
                      r.activityType || r.ActivityType || "-"
                    </td>
                    <td style={styles.td}>r.pageName || r.PageName || "-"</td>
                    <td style={styles.longTd}>
                      r.description || r.Description || "-"
                    </td>
                    <td style={styles.td}>r.ipAddress || r.IpAddress || "-"</td>
                    <td style={styles.longTd}>
                      r.userAgent || r.UserAgent || "-"
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="text-center text-muted"
                    style={{ ...styles.td, padding: 18 }}
                  >
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
